import React, { ReactNode } from 'react'
import { makeStyles, InputAdornment, TextField } from '@material-ui/core'
import { Field } from 'formik'
// import { useField } from 'formik'

const colors = {
  mainBlue: '#5A73EC',
  mainLightBlue: '#1592b4'
}

const useStyles = makeStyles({
  input: {
    margin: '15px 0 15px 0',
    outline: 0,
    '$:focus': {
      backgroundColor: 'black'
    },
    '& input[type-number]' : {
      MozAppearance: 'textfield'
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      WebkitAppearance: 'none'
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none'
    }
  },
  icon: {
    color: colors.mainBlue
  }
})

interface IInputProps {
  icon: ReactNode
  name: string
  type: string
  label: string
  required?: boolean
}
const Input: React.FC<IInputProps> = ({ icon, required = false, ...props }) => {
  const classes = useStyles()
  return (
    <Field
      as={TextField}
      className={classes.input}
      fullWidth={true}
      variant="outlined"
      {...props}
      required
      autoComplete="off"
      InputProps={{
        startAdornment: <InputAdornment position="start">{icon}</InputAdornment>,
        pattern: '[0-9]*'
      }}
    />
  )
}

export default Input
